import React from 'react';

import { Actionable } from 'root/widgets/common-components';

import { HideListingNudge } from 'root/widgets/hide-listing-nudge';
import { HiddenListingViewProps } from 'root/widgets/past-enquiry-view/types';

const HiddenListingView: React.FC<
  HiddenListingViewProps & { listingId?: number | string; isReasonSubmitted?: boolean }
> = ({
  title,
  undoText,
  undoAction,
  body,
  openPopupText,
  submittedReasonText,
  restore,
  onReasonPopupOpen,
  listingId,
  isReasonSubmitted,
}) => {
  const [isNudgeVisible, setNudgeVisible] = React.useState(true);

  const closeNudge = () => {
    setNudgeVisible(false);
  };

  const handleUndo = () => {
    if (restore && listingId) {
      restore(listingId);
    }
  };

  const handleOpenPopup = () => {
    if (onReasonPopupOpen && listingId) {
      onReasonPopupOpen(listingId);
    }
  };

  return (
    <>
      {isNudgeVisible && (
        <HideListingNudge>
          <HideListingNudge.Header
            title={title}
            undoText={undoText}
            closeAction={{
              onClick: closeNudge,
            }}
            undoAction={{
              ...undoAction,
              onClick: handleUndo,
            }}
          />
          <HideListingNudge.Body>{body}</HideListingNudge.Body>
          <HideListingNudge.Footer className="hide-listing-nudge-footer">
            {isReasonSubmitted ? (
              submittedReasonText
            ) : (
              <Actionable onClick={handleOpenPopup}>
                {openPopupText}
                <i className="pgicon pgicon-arrow-right" />
              </Actionable>
            )}
          </HideListingNudge.Footer>
        </HideListingNudge>
      )}
    </>
  );
};

export default HiddenListingView;
